import React, { Component } from "react";
import { bio } from "./data/bio.json";

class About extends Component {
  constructor() {
    super();
    this.state = {
      open: false
    };
  }
  componentDidMount() {
    this.setState({
      open: this.props.view === "desktop" ? true : false,
      desktop: this.props.view === "desktop" ? true : false,
      mobile: this.props.view === "desktop" ? false : true
    });
  }
  handleHeaderClick = e => {
    const { open } = this.state;
    if (this.state.desktop) {
      return;
    } else {
      this.setState({ open: !open });
    }
  };
  render() {
    const { open, mobile } = this.state;

    return (
      <div className="about-me--container content-section">
        <div
          className={`header--wrapper ${open ? "isShowing" : ""}`}
          onClick={this.handleHeaderClick}
          aria-controls="example-fade-text"
          aria-expanded={open}
        >
          <div className="dropdown-indicator">
            {mobile ? (open ? "-" : "+") : null}
          </div>

          <div className="collapse--header-text">About</div>
        </div>
        <div
          id="example-fade-text"
          className={`collape-text about-me-bio ${open ? "show" : ""} ${
            this.state.desktop ? "desktop" : ""
          }`}
        >
          {bio}
        </div>
      </div>
    );
  }
}

export default About;
